import React, { Component } from "react";
import { FormGroup, InputGroup, Button, NumericInput, Collapse, HTMLTable, Icon, Position } from "@blueprintjs/core";
import CustomSelect from "./../../components-fm/UISelect";

// ─────────────────────────────────────────────────────────────
// Constants (DB-aligned)
// ─────────────────────────────────────────────────────────────
// const GOAL_METHODS_v1 = [
//     { id: "open_play", name: "Șut din acțiune" },
//     { id: "set_piece", name: "Fază fixă" },
//     { id: "penalty", name: "Penalty" },
//     { id: "free_kick", name: "Lovitură liberă" },
//     { id: "header", name: "Cap" },
// ];

const GOAL_METHODS = [
    { id: "penalty", name: "Penalty" },
    { id: "set_piece_direct", name: "Fază fixă – direct" },
    { id: "set_piece_cross", name: "Fază fixă – centrare" },
    { id: "long_shot", name: "Șut din exteriorul careului" },
    { id: "box_shot", name: "Șut din interiorul careului" },
    { id: "one_on_one", name: "Singur cu portarul" },
    { id: "own_goal", name: "Autogol" },
    { id: "cross", name: "Centrare" },

];


const CARD_TYPES = [
    { id: "Y", name: "Galben" },
    { id: "R", name: "Roșu" },
    { id: "YR", name: "Al doilea galben (→ Roșu)" },
];

// Helpers simple pentru validare
const inRange = (v, min, max) => typeof v === "number" && !Number.isNaN(v) && v >= min && v <= max;

export default class GameInfoStats extends Component {
    state = {
        appTableOpen: true,
        appSortBy: "start",
        appSortDir: "asc",
        appSearch: "",

        goalsTableOpen: true,
        goalsDraftIndex: -1,

        cardsTableOpen: true,
        cardsDraftIndex: -1,
        subsTableOpen: true,

        againstTableOpen: true,
        againstDraftIndex: -1,
    };

    // ───────────────────────────────────────────────────────────
    // CRUD helpers
    // ───────────────────────────────────────────────────────────
    addRow = (section, def) => {
        const { stats, onChange } = this.props;
        const next = { ...stats, [section]: [...(stats[section] || []), def] };
        const synced = section === "subs" ? this.syncAppearancesWithSubs(next) : next;
        onChange(synced);
    };

    updateRow = (section, i, patch) => {
        const { stats, onChange } = this.props;
        const arr = [...(stats[section] || [])];
        arr[i] = { ...arr[i], ...patch };
        let next = { ...stats, [section]: arr };
        if (section === "subs") next = this.syncAppearancesWithSubs(next);
        onChange(next);

        // dacă editezi rândul-draft, nu mai e draft
        if (section === "goals" && this.state.goalsDraftIndex === i && this.isEditedGoal(arr[i])) {
            this.setState({ goalsDraftIndex: -1 });
        }
        if (section === "cards" && this.state.cardsDraftIndex === i && this.isEditedCard(arr[i])) {
            this.setState({ cardsDraftIndex: -1 });
        }
        if (section === "goals_against" && this.state.againstDraftIndex === i && this.isEditedAgainst(arr[i])) {
            this.setState({ againstDraftIndex: -1 });
        }

    };

    removeRow = (section, i) => {
        const { stats, onChange } = this.props;
        const arr = [...(stats[section] || [])];
        arr.splice(i, 1);
        let next = { ...stats, [section]: arr };
        if (section === "subs") next = this.syncAppearancesWithSubs(next);
        onChange(next); // ✅ eliminat dublura

        // întreținere index draft
        if (section === "goals") {
            const { goalsDraftIndex } = this.state;
            if (goalsDraftIndex === i) this.setState({ goalsDraftIndex: -1 });
            else if (goalsDraftIndex > i) this.setState({ goalsDraftIndex: goalsDraftIndex - 1 });
        }
        if (section === "cards") {
            const { cardsDraftIndex } = this.state;
            if (cardsDraftIndex === i) this.setState({ cardsDraftIndex: -1 });
            else if (cardsDraftIndex > i) this.setState({ cardsDraftIndex: cardsDraftIndex - 1 });
        }
        if (section === "goals_against") {
            const { againstDraftIndex } = this.state;
            if (againstDraftIndex === i) this.setState({ againstDraftIndex: -1 });
            else if (againstDraftIndex > i) this.setState({ againstDraftIndex: againstDraftIndex - 1 });
        }

    };

    // ───────────────────────────────────────────────────────────
    // Add buttons: împiedică rânduri goale multiple
    // ───────────────────────────────────────────────────────────
    addGoal = () => {
        if (this.state.goalsDraftIndex !== -1) return; // există deja un draft

        const { stats } = this.props;
        const goals = stats.goals || [];
        const last = goals[goals.length - 1];
        if (goals.length && !this.isEditedGoal(last)) return; // ultimul e gol -> nu mai adăugăm

        this.addRow("goals", {
            minute: "",
            stoppage: "",
            scorer_id: null,
            assist_id: null,
            method: "open_play",
            is_own_goal: 0,
            notes: "",
        });

        this.setState({ goalsDraftIndex: goals.length });
    };

    addCard = () => {
        if (this.state.cardsDraftIndex !== -1) return;
        const { stats } = this.props;
        const cards = stats.cards || [];
        const last = cards[cards.length - 1];
        if (cards.length && !this.isEditedCard(last)) return;

        this.addRow("cards", {
            minute: "",
            stoppage: "",
            player_id: null,
            card_type: "Y",
            reason: "",
        });
        this.setState({ cardsDraftIndex: cards.length });
    };

    addSub = () =>
        this.addRow("subs", {
            minute: "",
            stoppage: "",
            player_in_id: null,
            player_out_id: null,
        });

    addApp = () =>
        this.addRow("appearances", {
            player_id: null,
            start_minute: 0,
            end_minute: 90,
            rating: 10,
            notes: "",
        });

    addAgainst = () => {
        if (this.state.againstDraftIndex !== -1) return; // există deja un draft
        const { stats } = this.props;
        const arr = stats.goals_against || [];
        const last = arr[arr.length - 1];
        if (arr.length && !this.isEditedAgainst(last)) return;

        this.addRow("goals_against", {
            minute: "",
            stoppage: "",
            method: "box_shot", // default rezonabil
            notes: "",
        });
        this.setState({ againstDraftIndex: arr.length });
    };

    isEditedAgainst = (g) => {
        if (!g) return false;
        const hasMinute = g.minute !== "" && g.minute !== null && g.minute !== undefined;
        const hasStoppage = g.stoppage !== "" && g.stoppage !== null && g.stoppage !== undefined;
        const hasMethod = !!g.method;
        const hasNotes = !!(g.notes && String(g.notes).trim().length);
        return hasMinute || hasStoppage || hasMethod || hasNotes;
    };



    // ───────────────────────────────────────────────────────────
    // Validare minimă (UI-only)
    // ───────────────────────────────────────────────────────────
    validateStats = (stats) => {
        const errors = { goals: [], cards: [], subs: [], appearances: [] };

        // GOALS
        (stats.goals || []).forEach((g, i) => {
            const rowErr = {};
            const minuteNum = g.minute === "" ? null : Number(g.minute);
            const stoppageNum = g.stoppage === "" ? null : Number(g.stoppage);

            if (!(minuteNum === null || inRange(minuteNum, 0, 120))) rowErr.minute = "Minut 0–120 sau gol";
            if (!(stoppageNum === null || inRange(stoppageNum, 0, 15))) rowErr.stoppage = "+min 0–15 sau gol";
            if (!GOAL_METHODS.find((m) => m.id === g.method)) rowErr.method = "Metodă invalidă";
            errors.goals[i] = rowErr;
        });

        // GOALS AGAINST
        (errors.goals_against = []);
        (stats.goals_against || []).forEach((g, i) => {
            const rowErr = {};
            const minuteNum = g.minute === "" ? null : Number(g.minute);
            const stoppageNum = g.stoppage === "" ? null : Number(g.stoppage);

            if (!(minuteNum === null || inRange(minuteNum, 0, 120))) rowErr.minute = "Minut 0–120 sau gol";
            if (!(stoppageNum === null || inRange(stoppageNum, 0, 15))) rowErr.stoppage = "+min 0–15 sau gol";
            if (!GOAL_METHODS.find((m) => m.id === g.method)) rowErr.method = "Metodă invalidă";
            errors.goals_against[i] = rowErr;
        });


        // CARDS
        (stats.cards || []).forEach((c, i) => {
            const rowErr = {};
            const minuteNum = c.minute === "" ? null : Number(c.minute);
            const stoppageNum = c.stoppage === "" ? null : Number(c.stoppage);

            if (!(minuteNum === null || inRange(minuteNum, 0, 120))) rowErr.minute = "Minut 0–120 sau gol";
            if (!(stoppageNum === null || inRange(stoppageNum, 0, 15))) rowErr.stoppage = "+min 0–15 sau gol";
            if (!c.player_id) rowErr.player_id = "Selectează jucătorul";
            if (!CARD_TYPES.find((t) => t.id === c.card_type)) rowErr.card_type = "Tip invalid";
            errors.cards[i] = rowErr;
        });

        // SUBS
        (stats.subs || []).forEach((s, i) => {
            const rowErr = {};
            const minuteNum = s.minute === "" ? null : Number(s.minute);
            const stoppageNum = s.stoppage === "" ? null : Number(s.stoppage);

            if (!(minuteNum === null || inRange(minuteNum, 0, 120))) rowErr.minute = "Minut 0–120 sau gol";
            if (!(stoppageNum === null || inRange(stoppageNum, 0, 15))) rowErr.stoppage = "+min 0–15 sau gol";
            if (!s.player_in_id) rowErr.player_in_id = "Alegeți cine intră";
            if (!s.player_out_id) rowErr.player_out_id = "Alegeți cine iese";
            if (s.player_in_id && s.player_out_id && s.player_in_id === s.player_out_id) {
                rowErr.player_in_id = "Jucătorii trebuie să fie diferiți";
                rowErr.player_out_id = "Jucătorii trebuie să fie diferiți";
            }
            errors.subs[i] = rowErr;
        });

        // APPEARANCES — rating 1–20 (nu 0–10) + end > start
        (stats.appearances || []).forEach((a, i) => {
            const rowErr = {};
            const start = a.start_minute === "" ? null : Number(a.start_minute);
            const end = a.end_minute === "" ? null : Number(a.end_minute);
            const rating = a.rating === "" ? null : Number(a.rating);

            if (!a.player_id) rowErr.player_id = "Selectează jucătorul";
            if (!(start === null || inRange(start, 0, 120))) rowErr.start_minute = "Start 0–120 sau gol";
            if (!(end === null || inRange(end, 0, 120))) rowErr.end_minute = "Sfârșit 0–120 sau gol";
            if (end !== null && start !== null && end <= start) rowErr.end_minute = "+ trebuie > start";
            if (!(rating === null || inRange(rating, 1, 20))) rowErr.rating = "Notă 1–20 sau gol";
            errors.appearances[i] = rowErr;
        });

        return errors;
    };

    // Recalculează aparițiile (start/end) din SUBS + starters. Păstrează rating & notes.
    syncAppearancesWithSubs = (stats) => {
        const players = this.props.players || [];
        const subs = stats.subs || [];

        const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
        const byId = new Map(players.map((p) => [p.id, p]));

        const starterIds = players.filter((p) => Number(p.is_substitute) === 0).map((p) => p.id);

        const insByPlayer = new Map();
        const outsByPlayer = new Map();
        for (const s of subs) {
            const m = Number(s.minute ?? 0);
            if (s.player_in_id) {
                const arr = insByPlayer.get(s.player_in_id) || [];
                arr.push(m);
                insByPlayer.set(s.player_in_id, arr);
            }
            if (s.player_out_id) {
                const arr = outsByPlayer.get(s.player_out_id) || [];
                arr.push(m);
                outsByPlayer.set(s.player_out_id, arr);
            }
        }
        for (const arr of insByPlayer.values()) arr.sort((a, b) => a - b);
        for (const arr of outsByPlayer.values()) arr.sort((a, b) => a - b);

        const playedIds = new Set([...starterIds, ...insByPlayer.keys()]);
        const existing = new Map((stats.appearances || []).map((a) => [a.player_id, a]));

        const recomputed = [];
        for (const pid of playedIds) {
            const isStarter = starterIds.includes(pid);
            const start = isStarter ? 0 : insByPlayer.get(pid)?.[0] ?? 0;

            const outs = outsByPlayer.get(pid) || [];
            let end = 90;
            for (const outMin of outs) {
                if (outMin >= start) { end = outMin; break; }
            }

            const startClamped = clamp(Number(start) || 0, 0, 120);
            const endClamped = clamp(Number(end) || 90, startClamped, 120);

            const prev = existing.get(pid) || {};
            recomputed.push({
                player_id: pid,
                start_minute: startClamped,
                end_minute: endClamped,
                rating: prev.rating ?? 10,
                notes: prev.notes ?? "",
            });
        }

        // sort: după start, apoi nume
        recomputed.sort((a, b) => {
            if (a.start_minute !== b.start_minute) return a.start_minute - b.start_minute;
            const na = byId.get(a.player_id)?.name || "";
            const nb = byId.get(b.player_id)?.name || "";
            return na.localeCompare(nb);
        });

        return { ...stats, appearances: recomputed };
    };

    // ───────────────────────────────────────────────────────────
    // Draft detectors — folosite unitar peste tot
    // ───────────────────────────────────────────────────────────
    isEditedGoal = (g) => {
        if (!g) return false;
        const hasMinute = g.minute !== "" && g.minute !== null && g.minute !== undefined;
        const hasStoppage = g.stoppage !== "" && g.stoppage !== null && g.stoppage !== undefined;
        const hasScorer = !!g.scorer_id;
        const hasAssist = !!g.assist_id;
        const hasOwn = !!g.is_own_goal;
        const hasNotes = !!(g.notes && String(g.notes).trim().length);
        return hasMinute || hasStoppage || hasScorer || hasAssist || hasOwn || hasNotes;
    };



    isEditedCard = (c) => {
        if (!c) return false; // 👈 rând inexistent/gol NU e considerat “editat”
        const hasMinute = c.minute !== "" && c.minute !== null && c.minute !== undefined;
        const hasStoppage = c.stoppage !== "" && c.stoppage !== null && c.stoppage !== undefined;
        const hasPlayer = !!c.player_id; const hasReason = !!(c.reason && String(c.reason).trim().length);
        return hasMinute || hasStoppage || hasPlayer || hasReason;
    };


    // ───────────────────────────────────────────────────────────
    // Render
    // ───────────────────────────────────────────────────────────
    render() {
        const stats = this.props.stats || {};
        const players = this.props.players || [];

        const playerItems = players.map((p) => ({ id: p.id, name: p.name }));

        const goals = stats.goals || [];
        const cards = stats.cards || [];
        const subs = stats.subs || [];
        const apps = stats.appearances || [];

        const errors = this.validateStats(stats);

        const starters = players.filter((p) => Number(p.is_substitute) === 0);

        // pool marcatori = titulari ∪ cei care AU INTRAT
        const subInIds = new Set((subs || []).map((s) => s.player_in_id).filter(Boolean));
        const cameIn = players.filter((p) => subInIds.has(p.id));

        const scorerPoolMap = new Map();
        [...starters, ...cameIn].forEach((p) => scorerPoolMap.set(p.id, { id: p.id, name: p.name }));
        const baseScorerItems = Array.from(scorerPoolMap.values());

        // subs helpers pentru OUT/IN lists
        const bench = players.filter((p) => Number(p.is_substitute) === 1).map((p) => ({ id: p.id, name: p.name }));
        const subInIdsSet = new Set((subs || []).map((s) => s.player_in_id).filter(Boolean));
        const subOutIdsSet = new Set((subs || []).map((s) => s.player_out_id).filter(Boolean));

        const cameInItems = players.filter((p) => subInIdsSet.has(p.id)).map((p) => ({ id: p.id, name: p.name }));
        const outPoolMap = new Map();
        [...starters, ...cameInItems].forEach((it) => outPoolMap.set(it.id, it));
        const baseOutItems = Array.from(outPoolMap.values());
        const baseInItems = bench.filter((it) => !subInIdsSet.has(it.id));

        // 🔢 helpers pentru APPEARANCES
        const minutesOf = (r) => Math.max(0, Number(r.end_minute ?? 90) - Number(r.start_minute ?? 0));
        const norm = (s) => (s || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

        return (
            <div className="game-info-stats event-wrapper ">
                <h3 className="section-title">Statistici</h3>

                {/* GOALS */}
                <FormGroup
                    label={
                        <div className="stats-header">
                            <span
                                className="stats-header-label"
                                style={{ cursor: "pointer" }}
                                onClick={() => this.setState({ goalsTableOpen: !this.state.goalsTableOpen })}
                            >
                                Goluri <Icon icon={this.state.goalsTableOpen ? "chevron-up" : "chevron-down"} />
                                <img className='sm-img' src="/icons/game.png" alt="" />
                            </span>
                            {this.state.goalsTableOpen && (
                                <button
                                    className="uecl-button-outline"
                                    disabled={this.state.goalsDraftIndex !== -1}
                                    title={this.state.goalsDraftIndex === -1 ? "Adaugă gol" : "Completează rândul curent"}
                                    onClick={this.addGoal}
                                >
                                    Adaugă gol
                                </button>
                            )}
                        </div>
                    }
                    className="stats-section card-section"
                >
                    <Collapse isOpen={this.state.goalsTableOpen}>
                        <HTMLTable bordered condensed style={{ width: "100%", marginTop: 8 }} className="fm-table">
                            <thead>
                                <tr>
                                    <th style={{ width: "22%" }}>Marcator</th>
                                    <th style={{ width: "10%" }}>Min</th>
                                    <th style={{ width: "10%" }}>+Min</th>
                                    <th style={{ width: "22%" }}>Assist</th>
                                    <th style={{ width: "14%" }}>Metodă</th>
                                    <th style={{ width: "8%" }}>Autogol</th>
                                    <th>Note</th>
                                    <th style={{ width: 48 }} />
                                </tr>
                            </thead>
                            <tbody>
                                {(() => {
                                    const visibleGoals = (goals || []).filter((g, idx) => this.isEditedGoal(g) || idx === this.state.goalsDraftIndex);
                                    if (visibleGoals.length === 0) {
                                        return (
                                            <tr>
                                                <td colSpan={8} style={{ opacity: 0.7, fontStyle: "italic", textAlign: "center" }}>
                                                    Niciun gol adăugat încă.
                                                </td>
                                            </tr>
                                        );
                                    }
                                    return visibleGoals.map((g) => {
                                        const realIndex = goals.indexOf(g);
                                        const e = errors.goals[realIndex] || {};

                                        const selectedScorer = playerItems.find((p) => p.id === g.scorer_id) || null;
                                        let scorerItems = baseScorerItems;
                                        if (selectedScorer && !scorerPoolMap.has(selectedScorer.id)) {
                                            scorerItems = [...scorerItems, selectedScorer];
                                        }

                                        const selectedAssist = playerItems.find((p) => p.id === g.assist_id) || null;
                                        let assistItems = scorerItems.filter((x) => x.id !== (selectedScorer?.id || null));
                                        if (selectedAssist && !assistItems.some((x) => x.id === selectedAssist.id)) {
                                            assistItems = [...assistItems, selectedAssist];
                                        }

                                        return (
                                            <tr key={realIndex}>
                                                <td>
                                                    <CustomSelect
                                                        items={scorerItems}
                                                        selectedItem={selectedScorer}
                                                        onItemSelect={(it) => {
                                                            const newScorerId = it?.id || null;
                                                            const patch = { scorer_id: newScorerId };
                                                            if (newScorerId && g.assist_id === newScorerId) patch.assist_id = null;
                                                            this.updateRow("goals", realIndex, patch);
                                                        }}
                                                        popoverProps={{
                                                            minimal: true, usePortal: true, position: Position.BOTTOM_LEFT
                                                        }}
                                                        className="highlight-font-pink"
                                                    />
                                                </td>
                                                <td>
                                                    <NumericInput
                                                        placeholder="min"
                                                        min={0}
                                                        max={120}
                                                        value={g.minute === "" ? "" : Number(g.minute)}
                                                        onValueChange={(v) => this.updateRow("goals", realIndex, { minute: v })}
                                                        buttonPosition="none"
                                                    />
                                                    {e.minute && <div className="bp5-text-small bp5-text-danger">{e.minute}</div>}
                                                </td>
                                                <td>
                                                    <NumericInput
                                                        placeholder="+"
                                                        min={0}
                                                        max={15}
                                                        value={g.stoppage === "" ? "" : Number(g.stoppage)}
                                                        onValueChange={(v) => this.updateRow("goals", realIndex, { stoppage: v })}
                                                        buttonPosition="none"
                                                    />
                                                    {e.stoppage && <div className="bp5-text-small bp5-text-danger">{e.stoppage}</div>}
                                                </td>
                                                <td>
                                                    <CustomSelect
                                                        items={assistItems}
                                                        selectedItem={selectedAssist}
                                                        onItemSelect={(it) => this.updateRow("goals", realIndex, { assist_id: it?.id || null })}
                                                        className="highlight-font-green"
                                                        popoverProps={{
                                                            minimal: true, usePortal: true, position: Position.BOTTOM_LEFT
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <CustomSelect
                                                        items={GOAL_METHODS}
                                                        selectedItem={GOAL_METHODS.find((m) => m.id === g.method)}
                                                        onItemSelect={(it) => this.updateRow("goals", realIndex, { method: it.id })}
                                                        popoverProps={{
                                                            minimal: true, usePortal: true, position: Position.BOTTOM_LEFT
                                                        }}
                                                    />
                                                    {e.method && <div className="bp5-text-small bp5-text-danger">{e.method}</div>}
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    <label className="bp5-control bp5-switch" style={{ marginBottom: 0 }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={!!g.is_own_goal}
                                                            onChange={(ev) => this.updateRow("goals", realIndex, { is_own_goal: ev.target.checked ? 1 : 0 })}
                                                        />
                                                        <span className="bp5-control-indicator" />
                                                    </label>
                                                </td>
                                                <td>
                                                    <InputGroup
                                                        placeholder="Observații (opțional)"
                                                        value={g.notes || ""}
                                                        onChange={(e2) => this.updateRow("goals", realIndex, { notes: e2.target.value })}
                                                    />
                                                </td>
                                                <td>
                                                    <Button minimal icon="trash" intent="danger" onClick={() => this.removeRow("goals", realIndex)} />
                                                </td>
                                            </tr>
                                        );
                                    });
                                })()}
                            </tbody>
                        </HTMLTable>
                    </Collapse>
                </FormGroup>

                {/* GOALS AGAINST */}
                <FormGroup
                    label={
                        <div className="stats-header">
                            <span
                                className="stats-header-label"
                                style={{ cursor: "pointer" }}
                                onClick={() => this.setState({ againstTableOpen: !this.state.againstTableOpen })}
                            >
                                Goluri primite <Icon icon={this.state.againstTableOpen ? "chevron-up" : "chevron-down"} />
                                <img className='sm-img' src="/icons/goal-against.png" alt="" />
                            </span>
                            {this.state.againstTableOpen && (
                                <button
                                    className="uecl-button-outline"
                                    disabled={this.state.againstDraftIndex !== -1}
                                    title={this.state.againstDraftIndex === -1 ? "Adaugă gol primit" : "Completează rândul curent"}
                                    onClick={this.addAgainst}
                                >
                                    Adaugă gol primit
                                </button>
                            )}
                        </div>
                    }
                    className="stats-section card-section"
                >
                    <Collapse isOpen={this.state.againstTableOpen}>
                        <HTMLTable bordered condensed style={{ width: "100%", marginTop: 8 }} className="fm-table">
                            <thead>
                                <tr>
                                    <th style={{ width: "12%" }}>Min</th>
                                    <th style={{ width: "12%" }}>+Min</th>
                                    <th style={{ width: "26%" }}>Mod</th>
                                    <th>Note</th>
                                    <th style={{ width: 48 }} />
                                </tr>
                            </thead>
                            <tbody>
                                {(() => {
                                    const against = stats.goals_against || [];
                                    const visible = against.filter((g, idx) => this.isEditedAgainst(g) || idx === this.state.againstDraftIndex);
                                    if (visible.length === 0) {
                                        return (
                                            <tr>
                                                <td colSpan={5} style={{ opacity: 0.7, fontStyle: "italic", textAlign: "center" }}>
                                                    Niciun gol primit adăugat încă.
                                                </td>
                                            </tr>
                                        );
                                    }

                                    return visible.map((g) => {
                                        const realIndex = (stats.goals_against || []).indexOf(g);
                                        const e = (errors.goals_against || [])[realIndex] || {};

                                        return (
                                            <tr key={realIndex}>
                                                <td>
                                                    <NumericInput
                                                        placeholder="min"
                                                        min={0}
                                                        max={120}
                                                        value={g.minute === "" ? "" : Number(g.minute)}
                                                        onValueChange={(v) => this.updateRow("goals_against", realIndex, { minute: v })}
                                                        buttonPosition="none"
                                                    />
                                                    {e.minute && <div className="bp5-text-small bp5-text-danger">{e.minute}</div>}
                                                </td>
                                                <td>
                                                    <NumericInput
                                                        placeholder="+"
                                                        min={0}
                                                        max={15}
                                                        value={g.stoppage === "" ? "" : Number(g.stoppage)}
                                                        onValueChange={(v) => this.updateRow("goals_against", realIndex, { stoppage: v })}
                                                        buttonPosition="none"
                                                    />
                                                    {e.stoppage && <div className="bp5-text-small bp5-text-danger">{e.stoppage}</div>}
                                                </td>
                                                <td>
                                                    <CustomSelect
                                                        items={GOAL_METHODS}
                                                        selectedItem={GOAL_METHODS.find((m) => m.id === g.method)}
                                                        onItemSelect={(it) => this.updateRow("goals_against", realIndex, { method: it.id })}
                                                        popoverProps={{ minimal: true, usePortal: true, position: Position.BOTTOM_LEFT }}
                                                    />
                                                    {e.method && <div className="bp5-text-small bp5-text-danger">{e.method}</div>}
                                                </td>
                                                <td>
                                                    <InputGroup
                                                        placeholder="Observații (opțional)"
                                                        value={g.notes || ""}
                                                        onChange={(e2) => this.updateRow("goals_against", realIndex, { notes: e2.target.value })}
                                                    />
                                                </td>
                                                <td>
                                                    <Button minimal icon="trash" intent="danger" onClick={() => this.removeRow("goals_against", realIndex)} />
                                                </td>
                                            </tr>
                                        );
                                    });
                                })()}
                            </tbody>
                        </HTMLTable>
                    </Collapse>
                </FormGroup>


                {/* CARDS */}
                <FormGroup
                    label={
                        <div className="stats-header">
                            <span
                                className="stats-header-label"
                                style={{ cursor: "pointer" }}
                                onClick={() => this.setState({ cardsTableOpen: !this.state.cardsTableOpen })}
                            >
                                Cartonașe <Icon icon={this.state.cardsTableOpen ? "chevron-up" : "chevron-down"} />
                            </span>
                            {this.state.cardsTableOpen && (
                                <button
                                    className="uecl-button-outline"
                                    disabled={this.state.cardsDraftIndex !== -1}
                                    onClick={this.addCard}
                                >
                                    Adaugă cartonaș
                                </button>
                            )}
                        </div>
                    }
                    className="stats-section card-section"
                >
                    <Collapse isOpen={this.state.cardsTableOpen}>
                        <HTMLTable bordered condensed style={{ width: "100%", marginTop: 8 }} className="fm-table">
                            <thead>
                                <tr>
                                    <th style={{ width: "28%" }}>Jucător</th>
                                    <th style={{ width: "10%" }}>Min</th>
                                    <th style={{ width: "10%" }}>+Min</th>
                                    <th style={{ width: "16%" }}>Tip</th>
                                    <th>Motiv</th>
                                    <th style={{ width: 48 }} />
                                </tr>
                            </thead>
                            <tbody>
                                {(() => {
                                    const draftIndex = this.state.cardsDraftIndex;
                                    const visibleCards = (cards || []).filter((c, idx) => this.isEditedCard(c) || idx === draftIndex);

                                    if (visibleCards.length === 0) {
                                        return (
                                            <tr>
                                                <td colSpan={6} style={{ opacity: 0.7, fontStyle: "italic", textAlign: "center" }}>
                                                    Niciun cartonaș adăugat încă.
                                                </td>
                                            </tr>
                                        );
                                    }

                                    return visibleCards.map((c) => {
                                        const realIndex = cards.indexOf(c);
                                        const e = errors.cards[realIndex] || {};
                                        const selectedPlayer = playerItems.find((p) => p.id === c.player_id) || null;

                                        return (
                                            <tr key={realIndex}>
                                                <td>
                                                    <CustomSelect
                                                        items={playerItems}
                                                        selectedItem={selectedPlayer}
                                                        onItemSelect={(it) => this.updateRow("cards", realIndex, { player_id: it?.id || null })}
                                                        popoverProps={{
                                                            minimal: true, usePortal: true, position: Position.BOTTOM_LEFT
                                                        }}
                                                    />
                                                    {e.player_id && <div className="bp5-text-small bp5-text-danger">{e.player_id}</div>}
                                                </td>
                                                <td>
                                                    <NumericInput
                                                        placeholder="min"
                                                        min={0}
                                                        max={120}
                                                        value={c.minute === "" ? "" : Number(c.minute)}
                                                        onValueChange={(v) => this.updateRow("cards", realIndex, { minute: v })}
                                                        buttonPosition="none"
                                                    />
                                                    {e.minute && <div className="bp5-text-small bp5-text-danger">{e.minute}</div>}
                                                </td>
                                                <td>
                                                    <NumericInput
                                                        placeholder="+"
                                                        min={0}
                                                        max={15}
                                                        value={c.stoppage === "" ? "" : Number(c.stoppage)}
                                                        onValueChange={(v) => this.updateRow("cards", realIndex, { stoppage: v })}
                                                        buttonPosition="none"
                                                    />
                                                    {e.stoppage && <div className="bp5-text-small bp5-text-danger">{e.stoppage}</div>}
                                                </td>

                                                <td>
                                                    <CustomSelect
                                                        items={CARD_TYPES}
                                                        selectedItem={CARD_TYPES.find((t) => t.id === c.card_type)}
                                                        onItemSelect={(it) => this.updateRow("cards", realIndex, { card_type: it.id })}
                                                        popoverProps={{
                                                            minimal: true, usePortal: true, position: Position.BOTTOM_LEFT
                                                        }}
                                                    />
                                                    {e.card_type && <div className="bp5-text-small bp5-text-danger">{e.card_type}</div>}
                                                </td>
                                                <td>
                                                    <InputGroup
                                                        placeholder="Motiv"
                                                        value={c.reason || ""}
                                                        onChange={(e2) => this.updateRow("cards", realIndex, { reason: e2.target.value })}
                                                    />
                                                </td>
                                                <td>
                                                    <Button minimal icon="trash" intent="danger" onClick={() => this.removeRow("cards", realIndex)} />
                                                </td>
                                            </tr>
                                        );
                                    });
                                })()}
                            </tbody>
                        </HTMLTable>
                    </Collapse>
                </FormGroup>

                {/* SUBS */}
                <FormGroup
                    label={
                        <div className="stats-header">
                            <span
                                className="stats-header-label"
                                style={{ cursor: "pointer" }}
                                onClick={() => this.setState({ subsTableOpen: !this.state.subsTableOpen })}
                            >
                                Schimbări{" "}
                                <Icon icon={this.state.subsTableOpen ? "chevron-up" : "chevron-down"} />
                            </span>
                            {this.state.subsTableOpen && (
                                <button className="uecl-button-outline" onClick={this.addSub}>
                                    Adaugă schimbare
                                </button>
                            )}
                        </div>
                    }
                    className="stats-section card-section"
                >
                    <Collapse isOpen={this.state.subsTableOpen}>
                        <HTMLTable bordered condensed style={{ width: "100%", marginTop: 8 }} className="fm-table">
                            <thead>
                                <tr>
                                    <th style={{ width: "10%" }}>Min</th>
                                    <th style={{ width: "10%" }}>+Min</th>
                                    <th style={{ width: "28%" }}>Intră</th>
                                    <th style={{ width: "28%" }}>Iese</th>
                                    <th style={{ width: 48 }} />
                                </tr>
                            </thead>
                            <tbody>
                                {(subs || []).length === 0 ? (
                                    <tr>
                                        <td colSpan={5} style={{ opacity: 0.7, fontStyle: "italic", textAlign: "center" }}>
                                            Nicio schimbare adăugată încă.
                                        </td>
                                    </tr>
                                ) : (
                                    subs.map((s, i) => {
                                        const e = errors.subs[i] || {};

                                        const selectedIn = playerItems.find((p) => p.id === s.player_in_id) || null;
                                        const selectedOut = playerItems.find((p) => p.id === s.player_out_id) || null;

                                        const inItems = selectedIn && !baseInItems.some((x) => x.id === selectedIn.id)
                                            ? [...baseInItems, selectedIn]
                                            : baseInItems;

                                        let outItems = baseOutItems
                                            .filter((x) => x.id !== (selectedIn?.id || null))
                                            .filter((x) => !subOutIdsSet.has(x.id) || x.id === (selectedOut?.id || null));

                                        if (selectedOut && !outItems.some((x) => x.id === selectedOut.id)) {
                                            outItems = [...outItems, selectedOut];
                                        }

                                        return (
                                            <tr key={i}>
                                                <td>
                                                    <NumericInput
                                                        placeholder="min"
                                                        min={0}
                                                        max={120}
                                                        value={s.minute === "" ? "" : Number(s.minute)}
                                                        onValueChange={(v) => this.updateRow("subs", i, { minute: v })}
                                                        buttonPosition="none"
                                                    />
                                                    {e.minute && <div className="bp5-text-small bp5-text-danger">{e.minute}</div>}
                                                </td>

                                                <td>
                                                    <NumericInput
                                                        placeholder="+"
                                                        min={0}
                                                        max={15}
                                                        value={s.stoppage === "" ? "" : Number(s.stoppage)}
                                                        onValueChange={(v) => this.updateRow("subs", i, { stoppage: v })}
                                                        buttonPosition="none"
                                                    />
                                                    {e.stoppage && <div className="bp5-text-small bp5-text-danger">{e.stoppage}</div>}
                                                </td>

                                                <td>
                                                    <CustomSelect
                                                        items={inItems}
                                                        selectedItem={selectedIn}
                                                        onItemSelect={(it) => this.updateRow("subs", i, { player_in_id: it?.id || null })}
                                                        popoverProps={{
                                                            minimal: true, usePortal: true, position: Position.BOTTOM_LEFT
                                                        }}
                                                    />
                                                    {e.player_in_id && <div className="bp5-text-small bp5-text-danger">{e.player_in_id}</div>}
                                                </td>

                                                <td>
                                                    <CustomSelect
                                                        items={outItems}
                                                        selectedItem={selectedOut}
                                                        onItemSelect={(it) => this.updateRow("subs", i, { player_out_id: it?.id || null })}
                                                        popoverProps={{
                                                            minimal: true, usePortal: true, position: Position.BOTTOM_LEFT
                                                        }}
                                                    />
                                                    {e.player_out_id && <div className="bp5-text-small bp5-text-danger">{e.player_out_id}</div>}
                                                </td>

                                                <td>
                                                    <Button
                                                        minimal
                                                        icon="trash"
                                                        intent="danger"
                                                        onClick={() => this.removeRow("subs", i)}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </HTMLTable>
                    </Collapse>
                </FormGroup>

                {/* APPEARANCES */}
                <FormGroup
                    label={
                        <div className="stats-header">
                            <span
                                className="stats-header-label"
                                onClick={() => {
                                    const willOpen = !this.state.appTableOpen;
                                    this.setState({ appTableOpen: willOpen });
                                    if (willOpen) {
                                        const synced = this.syncAppearancesWithSubs(this.props.stats || {});
                                        this.props.onChange(synced);
                                    }
                                }}
                            >
                                Minute & rating <Icon icon={this.state.appTableOpen ? "chevron-up" : "chevron-down"} />
                            </span>
                            {this.state.appTableOpen && (
                                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                                    <InputGroup
                                        leftIcon="search"
                                        placeholder="Caută jucător…"
                                        value={this.state.appSearch}
                                        onChange={(e) => this.setState({ appSearch: e.target.value })}
                                        style={{ maxWidth: 260 }}
                                        className="search-input"
                                    />
                                </div>
                            )}
                        </div>
                    }
                    className="stats-section card-section"
                >
                    {(() => {
                        const playersById = new Map(players.map((p) => [p.id, p]));
                        const starterIds = players.filter((p) => Number(p.is_substitute) === 0).map((p) => p.id);

                        const sortedSubs = [...subs].sort((a, b) => (a.minute ?? 0) - (b.minute ?? 0));
                        const firstInMin = new Map();
                        const firstOutMin = new Map();
                        for (const s of sortedSubs) {
                            if (s.player_in_id && !firstInMin.has(s.player_in_id)) firstInMin.set(s.player_in_id, s.minute ?? 0);
                            if (s.player_out_id && !firstOutMin.has(s.player_out_id)) firstOutMin.set(s.player_out_id, s.minute ?? 0);
                        }

                        const playingIds = new Set([...starterIds, ...Array.from(firstInMin.keys())]);

                        const benchIds = players.filter((p) => Number(p.is_substitute) === 1).map((p) => p.id);
                        const benchUnusedIds = benchIds.filter((id) => !firstInMin.has(id));

                        const tableIds = new Set([...playingIds, ...benchUnusedIds]);
                        const appsByPlayer = new Map((apps || []).map((a) => [a.player_id, a]));

                        const rows = Array.from(tableIds).map((pid) => {
                            const p = playersById.get(pid);
                            const started = Number(p?.is_substitute) === 0;
                            const played = started || firstInMin.has(pid);
                            const computedStart = played ? (started ? 0 : firstInMin.get(pid) ?? 0) : 0;
                            const computedEnd = played ? firstOutMin.get(pid) ?? 90 : 0;

                            const existing = appsByPlayer.get(pid) || {};
                            return {
                                player_id: pid,
                                name: p?.name || "—",
                                start_minute: existing.start_minute ?? computedStart,
                                end_minute: existing.end_minute ?? computedEnd,
                                rating: existing.rating ?? (played ? 10 : null),
                                notes: existing.notes ?? "",
                            };
                        });

                        // sort implicit (înainte de filtrare): start, apoi nume
                        rows.sort((a, b) => a.start_minute - b.start_minute || (a.name || "").localeCompare(b.name || "", "ro"));

                        const rowsById = new Map(rows.map((r) => [r.player_id, r]));

                        const applyAppPatch = (playerId, patch) => {
                            const { stats, onChange } = this.props;
                            const arr = [...(stats.appearances || [])];
                            let idx = arr.findIndex((a) => a.player_id === playerId);
                            if (idx === -1) {
                                const base = rowsById.get(playerId) || { start_minute: 0, end_minute: 90, rating: 10, notes: "" };
                                arr.push({ player_id: playerId, ...base, ...patch });
                            } else {
                                arr[idx] = { ...arr[idx], ...patch };
                            }
                            onChange({ ...stats, appearances: arr });
                        };

                        // search + sort
                        const q = norm(this.state.appSearch || "");
                        let filteredRows = q ? rows.filter((r) => norm(r.name).includes(q)) : rows;

                        const sortBy = this.state.appSortBy || "start";
                        const sortDir = this.state.appSortDir || "asc";

                        filteredRows.sort((a, b) => {
                            let cmp = 0;
                            switch (sortBy) {
                                case "name":
                                    cmp = (a.name || "").localeCompare(b.name || "", "ro");
                                    break;
                                case "start":
                                    cmp = (a.start_minute ?? 0) - (b.start_minute ?? 0);
                                    break;
                                case "end":
                                    cmp = (a.end_minute ?? 90) - (b.end_minute ?? 90);
                                    break;
                                case "rating":
                                    cmp = (a.rating ?? 0) - (b.rating ?? 0);
                                    break;
                                case "mins":
                                    cmp = minutesOf(a) - minutesOf(b);
                                    break;
                                default:
                                    cmp = (a.start_minute ?? 0) - (b.start_minute ?? 0);
                            }
                            if (cmp === 0) cmp = (a.name || "").localeCompare(b.name || "", "ro");
                            return sortDir === "asc" ? cmp : -cmp;
                        });

                        const th = (label, key, width) => {
                            const active = this.state.appSortBy === key;
                            const dir = active ? this.state.appSortDir : null;
                            const toggle = () =>
                                this.setState({
                                    appSortBy: key,
                                    appSortDir: active && dir === "asc" ? "desc" : "asc",
                                });
                            return (
                                <th style={{ width, cursor: "pointer", userSelect: "none" }} onClick={toggle} title="Click pentru sortare">
                                    <span>{label}</span>
                                    <span style={{ marginLeft: 6, opacity: active ? 1 : 0.4 }}>{active ? (dir === "asc" ? "↑" : "↓") : "↕"}</span>
                                </th>
                            );
                        };

                        const rowClass = (r) => {
                            const mins = minutesOf(r);
                            if (mins === 90) return "app-row--full90";
                            if (mins === 0) return "app-row--dnp";
                            return undefined;
                        };

                        return (
                            <Collapse isOpen={this.state.appTableOpen}>
                                <HTMLTable bordered condensed style={{ width: "100%", marginTop: 8 }} className="fm-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "6%", textAlign: "right" }}>#</th>
                                            {th("Nume", "name", "26%")}
                                            {th("Minute", "mins", "12%")}
                                            {th("Start", "start", "12%")}
                                            {th("Sfârșit", "end", "12%")}
                                            {th("Notă (1–20)", "rating", "14%")}
                                            <th>Note</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredRows.map((r, idx) => (
                                            <tr key={r.player_id} className={rowClass(r)}>
                                                <td style={{ textAlign: "right", opacity: 0.8 }}>{idx + 1}</td>
                                                <td>{r.name}</td>
                                                <td style={{ textAlign: "center" }}>{minutesOf(r)}</td>
                                                <td>
                                                    <NumericInput
                                                        min={0}
                                                        max={120}
                                                        value={Number(r.start_minute ?? 0)}
                                                        onValueChange={(v) => applyAppPatch(r.player_id, { start_minute: v })}
                                                        buttonPosition={"none"}
                                                    />
                                                </td>
                                                <td>
                                                    <NumericInput
                                                        min={0}
                                                        max={120}
                                                        buttonPosition={"none"}
                                                        value={Number(r.end_minute ?? 90)}
                                                        onValueChange={(v) => applyAppPatch(r.player_id, { end_minute: v })}
                                                    />
                                                </td>
                                                <td>
                                                    <NumericInput
                                                        min={0}
                                                        max={20}
                                                        buttonPosition={"none"}
                                                        majorStepSize={1}
                                                        value={Number(r.rating ?? 0)}
                                                        onValueChange={(v) => applyAppPatch(r.player_id, { rating: v })}
                                                    />
                                                </td>
                                                <td>
                                                    <InputGroup
                                                        placeholder="Observații"
                                                        value={r.notes || ""}
                                                        onChange={(e) => applyAppPatch(r.player_id, { notes: e.target.value })}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </HTMLTable>
                            </Collapse>
                        );
                    })()}
                </FormGroup>
            </div>
        );
    }
}

// ─────────────────────────────────────────────────────────────
// Helper payload – aliniat cu API/DB
// ─────────────────────────────────────────────────────────────
export const buildGameStatsPayload = (stats) => {
    const toInt = (v) => (v === "" || v === null || v === undefined ? null : Number(v));
    const toFloat = (v) => (v === "" || v === null || v === undefined ? null : Number(v));
    const emptyToNull = (v) => (v === "" ? null : v);
    const reqInt = (v, def = 0) => (v === "" || v === null || v === undefined ? def : Number(v));


    // Anti-save helpers: ignorăm rândurile complet goale
    const _isEditedGoal = (g) => g && (
        g.minute !== "" || g.stoppage !== "" || g.scorer_id || g.assist_id || g.is_own_goal || (g.notes && String(g.notes).trim())
    );
    const _isEditedCard = (c) => c && (
        c.minute !== "" || c.stoppage !== "" || c.player_id || (c.reason && String(c.reason).trim())
    );
    const _isEditedSub = (s) => s && (
        s.minute !== "" || s.stoppage !== "" || s.player_in_id || s.player_out_id
    );
    const _isEditedApp = (a) => a && (
        a.player_id || a.start_minute !== "" || a.end_minute !== "" || a.rating !== "" || (a.notes && String(a.notes).trim())
    );

    // const goals = (stats.goals || []).map((g) => ({
    const goals = (stats.goals || []).filter(_isEditedGoal).map((g) => ({
        minute: reqInt(g.minute, 0),
        stoppage: toInt(g.stoppage),
        scorer_id: g.scorer_id || null,
        assist_id: g.assist_id || null,
        method: g.method || "open_play",
        is_own_goal: g.is_own_goal ? 1 : 0,
        notes: emptyToNull(g.notes),
    }));

    const mapCardType = (t) => {
        if (!t) return "Y";
        const up = String(t).toUpperCase();
        if (["Y", "R", "YR"].includes(up)) return up;
        if (t === "yellow") return "Y";
        if (t === "red") return "R";
        if (t === "second_yellow") return "YR";
        return "Y";
    };

    // const cards = (stats.cards || []).map((c) => ({
    const cards = (stats.cards || []).filter(_isEditedCard).map((c) => ({
        minute: reqInt(c.minute, 0),
        stoppage: toInt(c.stoppage),
        player_id: c.player_id || null,
        card_type: mapCardType(c.card_type),
        reason: emptyToNull(c.reason),
    }));

    // const subs = (stats.subs || []).map((s) => ({
    const subs = (stats.subs || []).filter(_isEditedSub).map((s) => ({
        minute: reqInt(s.minute, 0),
        stoppage: toInt(s.stoppage),
        player_out_id: s.player_out_id || null,
        player_in_id: s.player_in_id || null,
    }));

    const appearances = (stats.appearances || []).map((a) => ({
        player_id: a.player_id || null,
        start_minute: reqInt(a.start_minute, 0),
        end_minute: toInt(a.end_minute),
        rating: toFloat(a.rating), // UI permite 1–20
        notes: emptyToNull(a.notes),
    }));

    return { goals, cards, subs, appearances };
};
